import { BaseApi } from "./Base";

class BadgeApi extends BaseApi {
  getEmailPreferences(includeCounts) {
    return super.getApiRequest("/emailPreferences", { includeCounts });
  }

  creatEmailPreference(data) {
    return super.postApiRequest("/emailPreferences", data);
  }

  updateEmailPreferences(data) {
    return super.putApiRequest(`/emailPreferences`, data);
  }

  deleteEmailPreferences(id) {
    return super.deleteApiRequest(`/emailPreferences/${id}`);
  }
}

const badgeApi = new BadgeApi();

export default badgeApi;
